export type UnityConnectTransactionType = 'REFERRAL' | 'CIRF' | 'SHARED_DOCUMENT_PACKAGE' | 'PARTICIPATING_MATTER';

export const TransactionTypeValue = {
    referral : <UnityConnectTransactionType>'REFERRAL',
    cirf : <UnityConnectTransactionType>'CIRF',
    sharedDocumentPackage: <UnityConnectTransactionType>'SHARED_DOCUMENT_PACKAGE',
    participatingMatter: <UnityConnectTransactionType>'PARTICIPATING_MATTER'
};
